// ==============================|| FERRY OF ICON ||============================== //

const FerryOfIcon = ({ color = '#3b66b0', width = 24, className = '' }) => {
  const commonStyle = {
    fill: color,
    strokeWidth: '0px',
  };

  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16,5.3H4.1v4.2l5.9-2,4.9,1.6c.4-.1.7-.2,1.1-.2v-3.6Z"
        style={{ fill: 'none' }}
      />
      <path
        d="M2.1,11.6l1.1,4c.4-.2.7-.5,1-.8s.8-.9,1.6-1.9c.8,1,1.5,1.7,2,2.2s.7.5,1.1.7c.5-2.4,1.9-4.5,4-5.8l-3-1-7.8,2.6Z"
        style={{ fill: 'none' }}
      />
      <polygon
        points="4.1 9.5 4.1 9.5 4 9.5 4.1 9.5"
        style={{ fill: color }}
      />
      <path
        d="M8.9,15.8c-.4-.1-.8-.4-1.1-.7-.5-.5-1.2-1.2-2-2.2-.8,1-1.3,1.6-1.6,1.9s-.6.6-1,.8l-1.1-4,7.8-2.6,3,1c.6-.4,1.3-.7,2-.9l-4.9-1.6-5.9,2h0s0,0,0,0h0v-4.2h11.9v3.6c.4,0,.9-.1,1.4-.1s0,0,0,0v-3.3c0-.5-.1-1-.5-1.3-.4-.3-.8-.5-1.3-.5h-3.2V.7h-5v2.9h-3.2c-.5,0-1,.1-1.3.5-.3.4-.5.8-.5,1.3v4.5l-1.3.5c-.3,0-.5.3-.5.5v.6l1.7,6h-.2c.8,0,1.4-.2,2-.6.6-.4,1.1-.9,1.7-1.5.5.6,1.1,1.2,1.8,1.6.3.3.8.5,1.2.6,0,0,0-.2,0-.2,0-.5,0-1.1.2-1.6Z"
        style={commonStyle}
      />
      <path
        d="M8,19.7c-.7-.2-1.3-.6-1.9-1-.6.5-1.2.8-1.9,1s-1.4.3-2.1.3H.3v1.5h1.6c.7,0,1.4,0,2.1-.3s1.4-.5,2-.8c.7.4,1.3.6,2,.8.6.3,1.3.3,1.9.3-.3-.5-.5-1-.7-1.6-.4,0-.8-.1-1.2-.2Z"
        style={commonStyle}
      />
      <path
        d="M23.2,14.6c-.3-.8-.8-1.5-1.4-2.1-.6-.6-1.3-1.1-2.1-1.4-.8-.3-1.7-.5-2.6-.5s-1.8.2-2.6.5c-.8.3-1.5.8-2.1,1.4-.6.6-1.1,1.3-1.4,2.1-.3.8-.5,1.7-.5,2.6s.2,1.8.5,2.6.8,1.5,1.4,2.1c.6.6,1.3,1.1,2.1,1.4.8.3,1.7.5,2.6.5s1.8-.2,2.6-.5c.8-.3,1.5-.8,2.1-1.4.6-.6,1.1-1.3,1.4-2.1s.5-1.7.5-2.6-.2-1.8-.5-2.6ZM20.5,20.8l-7.8-6.3.8-1,7.8,6.3-.8,1Z"
        style={commonStyle}
      />
    </svg>
  );
};

export default FerryOfIcon;
